import Vue from 'vue'

const STORAGE_KEY = 'DEBUG'

const readDebugFlag = () => localStorage.getItem(STORAGE_KEY) === 'true'

const debugState = Vue.observable({
    enabled: readDebugFlag()
})

export const isDebugEnabled = () => readDebugFlag()

export const setDebugEnabled = (value) => {
    debugState.enabled = value
    localStorage.setItem(STORAGE_KEY, value)
}

export const toggleDebug = () => {
    setDebugEnabled(!debugState.enabled)
}

export const enableDebug = () => setDebugEnabled(true)

export const disableDebug = () => setDebugEnabled(false)

export const syncFromStorage = () => {
    debugState.enabled = readDebugFlag()
}

const DebugPlugin = {
    install(Vue) {
        Vue.prototype.$debug = debugState
    }
}

export default DebugPlugin
